import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserModule } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WaiterService } from '../_service/waiter.service';
import { PusherService } from '../_service/pusher.service';
@Component({
  selector: 'app-transactions',
  standalone: true,
  imports: [
    NgbModule,
    CommonModule,
    NgxPaginationModule,
    FormsModule
  ],
  providers: [DatePipe],
  templateUrl: './transactions.component.html',
  styleUrl: './transactions.component.scss'
})
export class TransactionsComponent implements OnInit, OnDestroy {
  Math = Math; // Add Math reference for template
  filter: string = '';
  loading = false; // Flag to handle initial loading state
  refreshing = false; // Flag to handle refresh loading state
  waiterRevenue: any;
  orders: any[] = [];
  totalAmount: number = 0;
  currentPage: number = 1;
  lastPage: number = 1;
  page: number = 1;
  waiterTransactions: any;
  itemsPerPage: any;
  total: any;
  filterType: string = '';
  startDate: string = '';
  endDate: string = '';
  showDatePicker: boolean = false;
  today: string = '';
  searchTerm: string = '';
  filteredTransactions: any[] = [];
  private refreshInterval: any;

  constructor(
    private router: Router,
    private service: WaiterService,
    private pusherService: PusherService,
    private datePipe: DatePipe
  ) {
    this.today = this.datePipe.transform(new Date(), 'yyyy-MM-dd')!;
  }
  ngOnInit(): void {
    this.fetchWaiterTransactions(true); // Initial load with loader
    // Set up interval to fetch transactions every 5 seconds
    this.refreshInterval = setInterval(() => {
      this.fetchWaiterTransactions(false); // Auto-refresh without loader
    }, 3000);
  }

  ngOnDestroy(): void {
    // Clean up the interval when component is destroyed
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  onPageChange(page: number): void {
    this.page = page;
    this.fetchWaiterTransactions(true); // Show loader for page changes
  }
  capitalizeFirstLetter(word: string) {
    if (!word) return '';  // Return an empty string if the input is not valid
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  fetchWaiterTransactions(showLoader: boolean = true) {
    if (showLoader) {
      this.loading = true;
      this.filteredTransactions = []; // Clear previous data immediately only for full loads
    } else {
      this.refreshing = true; // Show refresh indicator
    }

    // Build the request object dynamically
    const params: any = {
      page: this.page || 1,  // Ensure page is always at least 1
      filterType: this.filterType
    };
    if (this.startDate) params.startDate = this.startDate;
    if (this.endDate) params.endDate = this.endDate;

    this.service.fetchMonicreditTransactions(params)
      .subscribe({
        next: (res: any) => {
          this.waiterTransactions = res.data;
          this.filteredTransactions = this.waiterTransactions; // Initialize filtered data
          this.lastPage = res.meta.last_page;
          this.currentPage = res.meta.current_page;
          this.itemsPerPage = res.meta.per_page;
          this.total = res.meta.total;
        },
        error: (err: any) => {
          console.error('Transactions error:', err);
          if (showLoader) {
            this.filteredTransactions = []; // Clear data on error only for full loads
          }
        },
        complete: () => {
          this.loading = false;
          this.refreshing = false;
        }
      });
  }

  setDateFilter(filter: string) {
    console.log('Setting filter:', filter);
    this.filterType = filter;
    this.page = 1; // Reset to first page when changing filters
    const today = new Date();

    switch (filter) {
      case 'today':
        this.startDate = this.datePipe.transform(today, 'yyyy-MM-dd')!;
        this.endDate = this.startDate;
        break;
      case 'yesterday':
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        this.startDate = this.datePipe.transform(yesterday, 'yyyy-MM-dd')!;
        this.endDate = this.startDate;
        break;
      case 'weekly':
        const firstDayOfWeek = new Date(today);
        firstDayOfWeek.setDate(today.getDate() - today.getDay()); // Get Sunday of the current week
        this.startDate = this.datePipe.transform(firstDayOfWeek, 'yyyy-MM-dd')!;
        this.endDate = this.datePipe.transform(today, 'yyyy-MM-dd')!;
        break;
      case 'custom':
        this.showDatePicker = true;
        return;
      default:
        this.startDate = '';
        this.endDate = '';
    }

    this.showDatePicker = false;

    console.log('Calling API with:', {
      filterType: this.filterType,
      startDate: this.startDate || 'Not Sent',
      endDate: this.endDate || 'Not Sent'
    });

    this.fetchWaiterTransactions(true); // Show loader for filter changes
  }



  applyCustomDateFilter(start: string, end: string) {
    if (!start || !end) {
      console.error("Both start and end dates must be selected.");
      return;
    }

    console.log('Applying custom filter:', { start, end });
    this.filterType = 'custom';
    this.startDate = start;
    this.endDate = end;
    this.showDatePicker = false;
    this.page = 1; // Reset to first page

    this.fetchWaiterTransactions(true); // Show loader for custom filter
  }

  // Method to clear all filters
  clearFilters() {
    this.filterType = '';
    this.startDate = '';
    this.endDate = '';
    this.showDatePicker = false;
    this.page = 1;
    this.fetchWaiterTransactions(true); // Show loader for filter clearing
  }

  // Method to refresh data manually
  refreshTransactions() {
    this.fetchWaiterTransactions(false); // Manual refresh without full loader
  }
}
